import { Box, Icon, Tooltip } from '@chakra-ui/react';
import {
	AttachmentIcon,
	LockIcon,
	SpinnerIcon,
	StarIcon,
} from '@chakra-ui/icons';
import {
	FaGoogle,
	FaYandex,
	FaForumbee,
	FaInstagramSquare,
	FaFacebookSquare,
	FaVk,
	FaComments,
	FaFeatherAlt,
} from 'react-icons/fa';

import { channels, statuses } from '../app-data/admin';

const groupIcons = {
	google: FaGoogle,
	ya: FaYandex,
	forum: FaForumbee,
	ig: FaInstagramSquare,
	fb: FaFacebookSquare,
	vk: FaVk,
	socnet: FaComments,
	referral: FaFeatherAlt,
	other: FaComments,
};

export const displayChannel = (channel, details) => {
	if (!channel) return null;
	const icon = groupIcons[channel];
	const label = details
		? `${channels[channel]}: ${details}`
		: channels[channel];
	return (
		<Tooltip label={label} placement="top-start">
			<Box>
				<Icon as={icon} color="blue.500" />
			</Box>
		</Tooltip>
	);
};

export const displayStatus = status => (
	<Tooltip label={statuses[status]} placement="top-start">
		{
			{
				active: <StarIcon color="yellow.400" />,
				closed: <LockIcon color="orange.700" />,
				suspended: <SpinnerIcon color="orange.700" />,
				contract: <AttachmentIcon color="blue.700" />,
			}[status]
		}
	</Tooltip>
);
